import T from 'utils/T';
import ex from 'utils/ex';

export default function PageContent(props) {
  return (
    <div {...ex('PageContent', props)}/>
  );
}
